import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'p8-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss']
})
export class SettingsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
